/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderUserContext, FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { NumberTypes, whenCreateOrEditMode } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { SalesTaxRate } from '../../resources/estimating-sales-tax-rates-tab.model';

@Injectable()
export class EstimatingSalesTaxRateFormState extends FormState<SalesTaxRate> {

  constructor(schemaFactory: BuilderFormSchemaFactory,
              private userContext: BuilderUserContext) {
    super(schemaFactory);
  }

  protected buildSchema(salesTaxRate: SalesTaxRate, { root }: FormStateSchema): FormRootSchema {

    const isCreateMode = !salesTaxRate.id &&
      this.userContext.hasPermission(BuilderPermission.Setup.Estimating.SalesTaxRates.CREATE);

    const mode = isCreateMode
      ? FormMode.CreateMode
      : this.userContext.hasPermission(BuilderPermission.Setup.Estimating.SalesTaxRates.EDIT)
        ? FormMode.EditMode
        : FormMode.ViewMode;
    return root({
      enabled: whenCreateOrEditMode(),
      mode,
      optimisticLock: true,
      children: {
        id: void 0,
        name: { required: true },
        rate: { required: true, type: NumberTypes.Rate },
        isDefault: { enabled: !salesTaxRate.isDefault },
      },
    });
  }
}
